import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AssetPositionNotice',
  props: {
    message: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, {
    type: "info",
    variant: "tonal",
    icon: "mdi-map-marker-off-outline"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.message), 1)
    ]),
    _: 1
  }))
}
}

})